import React from 'react'

import DataGrid from '../UI/DataGrid'
import AgencyProducerCard from './AgencyProducerCard'

const ListAgencyProducers = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'fullName', title: 'Name' },
    { name: 'agency', title: 'Agency' },
    { name: 'title', title: 'Title' },
    { name: 'email', title: 'E-mail' },
    { name: 'formattedPhones', title: 'Phones' }
  ]

  const gridRowMappingFn = agencyProducer => {
    const id = agencyProducer.id
    const {
      fullName,
      title,
      email,
      formattedPhones
    } = agencyProducer.attributes

    const agency = agencyProducer.included('agency').attributes
    const agencyName = agency ? agency.name : 'N/A'

    return {
      id: id,
      fullName: fullName,
      agency: agencyName,
      title: title,
      email: email,
      formattedPhones: formattedPhones
    }
  }

  const gridSorting = [{ columnName: 'fullName', direction: 'asc' }]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'fullName', togglingEnabled: false }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="agency-producers"
      resourceSingularName="External project manager"
      resourcePluralName="External project managers"
      resourceIncludes={['agency']}
      nameAttribute="fullName"
      clientRootPath="/agency-producers"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      cannotDelete
      detailsCard={AgencyProducerCard}
    />
  )
}

export default ListAgencyProducers



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/ListAgencyProducers.jsx